module.exports = __webpack_public_path__ + "static/media/18.9f75f891.gif";